export default __webpack_public_path__ + "static/media/runkeeper-comp.f104b6dc.svg";